module.exports = __webpack_public_path__ + "static/media/mode-49.7754963c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-49.svg
// module id = 1003
// module chunks = 2